<template>
  <div>
    <div id="app">
      <router-view/>
    </div><!-- app_layer -->
    <div id="popup_layer"></div><!-- popup_layer -->
    <div id="comp_layer"></div><!-- comp_layer -->
    <loading :visible="showLoading" @close="closeLoading"></loading><!-- load_layer -->
    <div id="alert_layer"></div><!-- alert_layer -->
  </div>
</template>

<script>
import Loading from '@/views/components/Loading';
export default {
  components: {
    Loading,
  },
  computed: {
    showLoading () { return this.$store.getters['loading/show_loading']; },
  },
  methods: {
    closeLoading () {
      this.$store.commit('loading/set_loading', false);
    },
  },
};
</script>
<style lang="scss">
/************
* scss init
************/
* {
  margin: 0px;
  padding: 0px;
  margin-block-start: 0;
  margin-block-end: 0;
  font-family:"游ゴシック体",YuGothic,"游ゴシック Medium","Yu Gothic Medium","ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","メイリオ",Meiryo,sans-serif;
}
body {
  background: #ffffff;
}
table {

  border-collapse: collapse;
  border-spacing: 0px;
}
li {
  text-decoration: none;
  list-style: none;
}

/************
* scss common
************/
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#popup_layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 16, 56, 0.9);
  display: none;
}
#alert_layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: none;
  z-index: 10000;
}
.c-c-light {
  color: $c-green-light-color;
}
.c-c {
  color: $c-green-color;
}
.c-c-deep {
  color: $c-green-deep-color;
}
.c-c-dark {
  color: $c-green-dark-color;
}
.c-bg-s-light {
  background-color: $c-green-super-light-color;
}
.c-bg-light {
  background-color: $c-green-light-color;
}
.c-bg {
  background-color: $c-green-color;
}
.c-bg-deep {
  background-color: $c-green-deep-color;
}
.c-bg-dark {
  background-color: $c-green-dark-color;
}

.c-bc-light {
  border-color: $c-green-light-color;
}
.c-bc {
  border-color: $c-green-color;
}
.c-bc-deep {
  border-color: $c-green-deep-color;
}
.c-bc-dark {
  border-color: $c-green-dark-color;
}
.clear-both::after {
    content: "";
    display: block;
    clear: both;
}

.button,
button {
  outline: 0;
  background: #1b2010;
  cursor: pointer;
}

.button:hover,
button:hover {
  background-color: #df274c;
}

.button:disabled,
button:disabled {
  background-color: #f0eeed;
  cursor: default;
}
/* checkbox */
input[type="checkbox"] {
  display: none;
}
input[type="checkbox"] + label {
  padding-left: 25px;
  position:relative;
  margin-right: 20px;
  font-weight: bold;
  color: #da7d78;
  text-decoration: underline;
  box-sizing: border-box;
  cursor: pointer;
}
input[type="checkbox"] + label::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 19px;
  height: 19px;
  border: 1px solid #da7d78;
  border-radius: 4px;
  background-color: #FFF;
}
input[type="checkbox"]:checked + label {
  color: #df274c;
  text-decoration: none;
}
input[type="checkbox"]:checked + label::before{
  border-color: #801e31;
}
input[type="checkbox"]:checked + label::after {
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  left: 6px;
  width: 10px;
  height: 16px;
  transform: rotate(40deg);
  border-bottom: 3px solid #df274c;
  border-right: 3px solid #df274c;
}
/* radio */
input[type="radio"] {
    display: none;
}
input[type="radio"] + label{
    padding-left: 25px;
    position:relative;
    margin-right: 30px;
    font-weight: bold;
    color: #da7d78;
    text-decoration: underline;
    box-sizing: border-box;
    cursor: pointer;
}
input[type="radio"] + label::before{
    content: "";
    display: block;
    position: absolute;
    top: -3px;
    left: -3px;
    width: 21px;
    height: 21px;
    border: 1px solid #da7d78;
    border-radius: 50%;
    background-color: #FFF;
}
input[type="radio"]:checked + label{
    color: #df274c;
    text-decoration: none;
}
input[type="radio"]:checked + label::before{
  border-color: #801e31;
}
input[type="radio"]:checked + label::after{
    content: "";
    display: block;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 7px;
    height: 7px;
    background: #df274c;
    border-radius: 50%;
}

input[type="text"],
input[type="email"],
input[type="url"],
input[type="password"],
textarea{
    width: 100%;
    border: none;
    border-radius: 0;
    padding: 0;
    outline: 0;
    font-size: 1rem;
    resize: none;
    box-sizing: border-box;
    border-radius: 0;
    background-color: #fff;
    border-color: #dfafb6;
}

input[type="text"],
input[type="url"],
input[type="password"],
textarea {
    border: 1px solid #dfafb6;
    padding: 3px 5px;
    &:focus {
        border-color: #df274c;
    }
}
input[type="text"]:disabled,
input[type="url"]:disabled,
input[type="password"]:disabled,
textarea:disabled {
  background-color: #eee;
}
::-webkit-input-placeholder, { /* WebKit, Blink, Edge */
    color:#bbb;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color:#bbb;
}
::placeholder{ /* Others */
    color:#bbb;
}

input[type="submit"] {
  -webkit-appearance: none;
  border-radius: 0;
}

select {
  outline: 0;
}

select > option {
  background-color: #fff;
}
select:hover {
}
</style>
